import { z } from "zod";
import { Integration } from "../integrations/integration";
import { Workspace } from "../workspace/workspace";
import { CodeIntegrationDump } from "./code-integration-dump";
import { DesignSystemDump } from "./design-system-dump";

export const WorkspaceDump = z.object({
  workspace: Workspace,
  designSystems: DesignSystemDump.array(),
  codeIntegration: CodeIntegrationDump,
  integrations: Integration.array(),
});

export type WorkspaceDump = z.infer<typeof WorkspaceDump>;
